import { memo } from "react";
import PropTypes from "prop-types";
import NegociatedItem, {
	TYPES_WITH_SPECIFIC_ICON,
} from "app/pages/FicheProduit/NegociatedList/NegociatedItem";
import EmiratesPassNegociatedItem from "app/pages/FicheProduit/NegociatedList/EmiratesPassNegociatedItem";
import { FormattedMessage } from "react-intl";
import "./NegociatedList.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { ICON_SIZES } from "app/constants";

const renderNegociatedItem = (
	negociated,
	index,
	{ offerWithTransportLabel, specialOffer, sizeIcon }
) => (
	<li key={index} className="negociated-list__item">
		<NegociatedItem
			type={negociated.type}
			label={negociated.label}
			isTransportOnly={negociated.isTransportOnly}
			offerWithTransportLabel={offerWithTransportLabel}
			specialOffer={specialOffer}
			sizeIcon={sizeIcon}
			labelVariantMD={TYPOGRAPHY_VARIANTS.LARGE}
		/>
	</li>
);

const NegociatedList = ({
	negociatedList,
	specialOffer,
	offerWithTransportLabel,
	sizeIcon,
	showEmiratesPassItem,
}) => {
	const itemProps = { offerWithTransportLabel, specialOffer, sizeIcon };
	const iconItems = negociatedList.filter(item => TYPES_WITH_SPECIFIC_ICON.includes(item.type));
	const checkItems = negociatedList.filter(item => !TYPES_WITH_SPECIFIC_ICON.includes(item.type));

	return (
		<div className="negociated-list" data-testid="negotiated-list">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				variantMD={TYPOGRAPHY_VARIANTS.XL4}
				isBold
				className="negociated-list__title"
				component="h2"
			>
				<FormattedMessage id="product.page.negociated.title" />
			</Typography>
			<ul className="negociated-list__list">
				{iconItems.map((negociated, index) =>
					renderNegociatedItem(negociated, index, itemProps)
				)}
				{showEmiratesPassItem && (
					<li className="negociated-list__item">
						<EmiratesPassNegociatedItem
							sizeIcon={sizeIcon}
							labelVariantMD={TYPOGRAPHY_VARIANTS.LARGE}
						/>
					</li>
				)}
				{checkItems.map((negociated, index) =>
					renderNegociatedItem(negociated, iconItems.length + index, itemProps)
				)}
			</ul>
		</div>
	);
};

NegociatedList.propTypes = {
	negociatedList: PropTypes.array,
	specialOffer: PropTypes.object,
	offerWithTransportLabel: PropTypes.string,
	sizeIcon: PropTypes.oneOf(Object.values(ICON_SIZES)),
	showEmiratesPassItem: PropTypes.bool,
};

NegociatedList.defaultProps = {
	negociatedList: [],
	specialOffer: {},
};

export default memo(NegociatedList);
